import { merge } from 'lodash';
import { fetchTPASettingsSuccess, updateTPASettingsSuccess, } from './tpa-settings-actions';
export const INITIAL_STATE = {
    settings: {},
    translations: {},
};
const tpaSettingsReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case updateTPASettingsSuccess.toString():
        case fetchTPASettingsSuccess.toString():
            return merge({}, state, action.payload);
        default:
            return state;
    }
};
export default tpaSettingsReducer;
//# sourceMappingURL=tpa-settings-reducer.js.map